import requestServer from '../request-server';

let internals = {};

// Analytics API to send events with the required format
internals.sendAnalyticsEvent = function (data) {
  // data: { event_name, source, version, unique_id, logs }
  return requestServer(
    'v1/user/analytics',
    data,
    'POST',
    {},
    'application/json',
    true
  );
};

export default internals; 